(ns bleene.root
  (:require
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [bleene.app.events]
   [bleene.app.subs]
   [bleene.layout.core :as fl.layout]))


(defn root []
  (re-frame/dispatch-sync [:app/initialize])
  (fn []
    [fl.layout/base-page]))


(defn root-dispatcher [params]
  [root params])
